<template>
  <div v-if="totalPages > 1" class="table-footer">
    <p class="table-footer-text">
      Showing <strong>{{ showingCount }}</strong> of <strong>{{ totalItems }}</strong> {{ itemLabel }}
    </p>
    <div class="table-footer-btns">
      <button
        class="pagination-btn"
        :disabled="currentPage <= 1"
        @click="$emit('page-change', currentPage - 1)"
      >
        <ChevronLeft class="h-4 w-4" />
      </button>
      <button
        v-for="page in totalPages"
        :key="page"
        class="pagination-btn"
        :class="{ 'pagination-btn--active': page === currentPage }"
        @click="$emit('page-change', page)"
      >
        {{ page }}
      </button>
      <button
        class="pagination-btn"
        :disabled="currentPage >= totalPages"
        @click="$emit('page-change', currentPage + 1)"
      >
        <ChevronRight class="h-4 w-4" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ChevronLeft, ChevronRight } from 'lucide-vue-next'

withDefaults(defineProps<{
  currentPage: number
  totalPages: number
  totalItems: number
  showingCount: number
  itemLabel?: string
}>(), {
  itemLabel: 'items',
})

defineEmits<{
  'page-change': [page: number]
}>()
</script>

<style scoped>
.table-footer {
  @apply flex flex-col sm:flex-row items-center justify-between gap-3
         px-6 py-3.5
         border-t-2 border-gray-100 dark:border-gray-700/50
         bg-gray-50/50 dark:bg-gray-800/50;
}
.table-footer-text {
  @apply text-xs text-gray-400 dark:text-gray-500;
}
.table-footer-btns {
  @apply flex items-center gap-1.5;
}
.pagination-btn {
  @apply h-8 min-w-[2rem] flex items-center justify-center rounded-lg
         text-sm font-medium text-gray-500 dark:text-gray-400
         hover:bg-gray-200 dark:hover:bg-gray-700
         disabled:opacity-40 disabled:cursor-not-allowed transition-colors duration-100;
}
.pagination-btn--active {
  @apply bg-primary text-white hover:bg-primary-hover
         dark:bg-primary-dark dark:hover:bg-primary-dark-hover;
}
</style>
